/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Passkey_UnsupportedInputs */



/**
* | output |
* | --- |
* | "This browser cannot use a passkey. Use the email link instead." |
*
* @param {Portalsignin_Passkey_UnsupportedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalsignin_passkey_unsupported = /** @type {((inputs?: Portalsignin_Passkey_UnsupportedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Passkey_UnsupportedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("This browser cannot use a passkey. Use the email link instead.")
});